import { useState, useEffect } from "react";
import { canadaRahulPhoto, canadaStripeUrl, canadaNavData } from "../../data/canadaTaxData";
import { Menu, X, ArrowRight } from "lucide-react";

export const CanadaNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/97 shadow-md shadow-black/5" : "bg-white border-b border-[#E8ECF0]"
      }`}
      style={{ backdropFilter: "blur(12px)" }}
    >
      <div className="max-w-[87.5rem] mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3.5 cursor-pointer">
          <img
            src={canadaRahulPhoto}
            alt="CA Rahul Taneja"
            className="w-11 h-11 rounded-full object-cover border-2 border-[#C8283A]/20 shadow-sm"
          />
          <div className="flex flex-col leading-none">
            <span className="text-[#0B1829] font-black text-base" style={{ fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "-0.02em" }}>
              CA Rahul Taneja
            </span>
            <span className="text-[#8BA3BE] text-[10px] font-semibold uppercase tracking-widest mt-0.5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {canadaNavData.logoSub}
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-7">
          {canadaNavData.links.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollTo(l.href)}
              className="text-[#5A6A7A] hover:text-[#C8283A] text-xs font-semibold uppercase tracking-wider transition-colors duration-200"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {l.label}
            </button>
          ))}
          <a
            href={canadaStripeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 bg-[#C8283A] text-white font-bold text-xs px-5 py-2.5 rounded-full transition-all duration-200 hover:bg-[#A01828] hover:scale-[1.02] uppercase tracking-tight inline-flex items-center gap-1.5"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            {canadaNavData.ctaText}
            <ArrowRight size={12} />
          </a>
        </div>

        {/* Mobile burger */}
        <button
          className="md:hidden text-[#0B1829] p-1"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-[#E8ECF0] px-6 py-4 flex flex-col gap-3">
          {canadaNavData.links.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollTo(l.href)}
              className="text-[#5A6A7A] text-sm font-semibold uppercase tracking-wider text-left py-2 border-b border-[#F3F5F8]"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {l.label}
            </button>
          ))}
          <a
            href={canadaStripeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 bg-[#C8283A] text-white font-bold text-sm px-6 py-3.5 rounded-full uppercase tracking-tight text-center"
          >
            {canadaNavData.ctaText}
          </a>
        </div>
      )}
    </nav>
  );
};
